import fetch from '../utils/fetch';

export const getEmail = (userID) => {
	return fetch('get', `/email/test?user=${userID}`);
};

export const sendEmail = (userID) => {
	return fetch('post', `/email/test?user=${userID}`);
};
